import { render } from "./DefectsUserLists.vue?vue&type=template&id=fcb2f922"
import script from "./DefectsUserLists.vue?vue&type=script&lang=js"
export * from "./DefectsUserLists.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__